import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import dateformat from 'dateformat';

import { Row, Col, OverlayTrigger, Image, Tooltip } from 'react-bootstrap';
import { AreaChart, Area, XAxis, } from 'recharts';
import Measure from 'react-measure';

import styles from './styles.module.scss';
import { localizedStrings } from "../../../../localization/index";

class VideoAnalyticsGraphRowView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      segments: [],
      chart: {
        width: 250,
        visible: false
      }
    }
    this._handleChartMouseMove = this._handleChartMouseMove.bind(this);
    this._handleChartMouseOut = this._handleChartMouseOut.bind(this);
    this.formatTimeSpent = this.formatTimeSpent.bind(this);
    this._handleMouseOut = this._handleMouseOut.bind(this);

    // localized contents
    this.localizedKeywords = localizedStrings.keywords;
    this.localizedCommons = localizedStrings.commons;
  }

  componentDidMount() {
    var analytics = this.props.analytics;
    if (analytics && analytics.dataPoints) {
      var processedData = this.processAnalytics(analytics);

      this.setState({
        ...processedData
      })
    }
  }

  processAnalytics(analytics) {
    if (!analytics || analytics.dataPoints.length == 0) {
      return [];
    }

    var segmentLength = this.props.asset.metadata.video_segment_length || 5;
    var totalDuration = this.props.asset.metadata.video_duration || 0;

    if (totalDuration == 0) {
      var lastSegment = analytics.dataPoints[analytics.dataPoints.length - 1];
      totalDuration = lastSegment.index + segmentLength;
    }

    var segmentCounts = Math.ceil(totalDuration / segmentLength);
    segmentCounts = Math.max(segmentCounts, analytics.dataPoints.length);

    var segments = []
    for (var i = 0; i < segmentCounts; i++) {
      var segment = {
        index: i * segmentLength,
        totalTimeSpent: 0.0,
        count: 0
      }

      segments.push(segment);
    }

    analytics.dataPoints.forEach((element) => {
      var index = segments.findIndex(item => {
        return item.index == element.index;
      });

      if (index != -1) {
        segments[index] = element;
      }

    })

    return {
      segments: segments,
      segmentLength: segmentLength,
      duration: totalDuration
    }
  }

  render() {
    if (this.state.segments.length == 0 || this.props.analytics.type != 'VIDEO_ANALYTICS') {
      return null;
    }

    let activeSegment = this.state.activeSegment || {
      index: 0,
      totalTimeSpent: 0,
      count: 0
    };

    let timeSpent = activeSegment.index;
    let views = this.padNumber(activeSegment.count, 2);

    return (
      <div className={styles.pageMetrics}>
        <div className={styles.noPadding}>
          {this.props.lastViewedDate &&
            <h5 className={styles.lastViewed}>{this.localizedCommons.last_viewed} {dateformat(this.props.lastViewedDate, 'dd mmm yyyy')}</h5>
          }
            <div className={this.props.className ? '' : styles.pageData}>
           <div className={this.props.className ? this.props.className : styles.pageNumber}>{this.localizedCommons.views} # {views}</div>
              <div className={styles.timeSpent}>
                {this.localizedCommons.time.time}: {this.formatTimeSpent(timeSpent)}
              </div>
            </div>
          
        </div>
        <div className={styles.noPadding}>
          {this.renderVideoAnalytics()} 
        </div>
      </div>
    )
  }

  _handleMouseOut(e) {
    this.setState({
      activeSegment: null,
      seekTime: 0
    })
  }


  renderVideoAnalytics() {

    var segmentCounts = this.state.segments.length;
    var width = this.state.chart.width;

    let height = 68;

    return (
      <Measure bounds
        onResize={(contentRect) => {
          this.setState({
            chart: {
              ...this.state.chart,
              width: contentRect.bounds.width,
              height: contentRect.bounds.height
            }
          })
        }}>

        {({ measureRef }) =>
          <div ref={measureRef} className={styles.assetViewChart}>
            <AreaChart width={width} height={height}
              data={this.state.segments}
              onMouseMove={this._handleChartMouseMove}
              onMouseLeave={this._handleChartMouseOut}
            >
              <XAxis dataKey="index" hide={true} tick={false} />
              <Tooltip content={this.renderToolTip} />

              <Area
                type="monotone"
                dataKey='count'
                yAxisId='count'
                fill='#7f7f7f'
                stroke='#000'
                strokeWidth={2}
              >
              </Area>

            </AreaChart>
          </div>
        }
      </Measure>
    );

  };

  renderToolTip(o) {
    return false;
  }
  _handleChartMouseOut() {
    this.setState({
      activeIndex: 0,
      seekTime: 0,
      activeSegment: null
    })
  }
  _handleChartMouseMove(data, index) {
    if (!(data.activeCoordinate && data.activePayload)) {
      return;
    }

    var seekTime = data.activeCoordinate.x / this.state.chart.width;
    var totalDuration = this.state.duration;
    seekTime = seekTime * totalDuration;

    this.setState({
      activeIndex: index,
      seekTime: seekTime,
      activeSegment: data.activePayload[0].payload
    })
  }


  padNumber(number = 0, pad) {
    number = Math.ceil(number);

    const length = pad - String(number).length + 1;
    let padding = '';
    if (length > 0) {
      padding = Array(pad - String(number).length + 1).join('0');
    }
    return padding + number;
  }

  formatTimeSpent(timeSpent) {
    let minutes = this.padNumber(Math.floor(timeSpent / 60), 2);
    let seconds = this.padNumber(timeSpent % 60, 2);

    return `${minutes}:${seconds}`;
  }
}
VideoAnalyticsGraphRowView.contextType ={
 lite : PropTypes.boolean

}

export default VideoAnalyticsGraphRowView;
























































































































